var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull mainBackground h-100 back-1" },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container dataContainer" }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { id: "editUser" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.editUser.apply(null, arguments)
              }
            }
          },
          [
            _c("div", { staticClass: "row justify-content-center mt-5 pb-5" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 0, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.company,
                        expression: "company"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 128, min: 2 },
                        expression: "{ required: true, max: 128, min: 2 }"
                      }
                    ],
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("company"),
                      valid: !!_vm.company
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "company",
                      name: "company",
                      "data-vv-as": "Ragione sociale"
                    },
                    domProps: { value: _vm.company },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.company = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "company" }
                    },
                    [_vm._v("Ragione sociale\n            ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("company")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("company")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 1, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.piva,
                        expression: "piva"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 11, min: 11 },
                        expression: "{ required: true, max: 11, min: 11 }"
                      }
                    ],
                    staticClass: "dis form-control",
                    class: {
                      "is-invalid": _vm.errors.has("piva"),
                      valid: !!_vm.piva
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "piva",
                      name: "piva",
                      "data-vv-as": "Partita IVA"
                    },
                    domProps: { value: _vm.piva },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.piva = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "piva" } },
                    [_vm._v("Partita IVA ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("piva")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("piva")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 2, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.cod,
                        expression: "cod"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { required: true, max: 11, min: 5 },
                        expression: "{ required: true, max: 11, min: 5 }"
                      }
                    ],
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("cod"),
                      valid: !!_vm.cod
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "cod",
                      name: "cod",
                      "data-vv-as": "Codice Utente"
                    },
                    domProps: { value: _vm.cod },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.cod = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "piva" } },
                    [_vm._v("Codice utente ")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("cod")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("cod")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 3, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: true,
                          email: true,
                          temporaryEmail: true,
                          plusIssueEmail: true,
                          max: 56
                        },
                        expression:
                          "{\n                required: true,\n                email: true,\n                temporaryEmail: true,\n                plusIssueEmail: true,\n                max: 56,\n              }"
                      }
                    ],
                    ref: "email",
                    staticClass: "form-control dis",
                    class: {
                      "is-invalid": _vm.errors.has("email") || _vm.existEmail,
                      valid: !!_vm.email
                    },
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: "email",
                      name: "email",
                      "data-vv-as": "Email"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "email" } },
                    [_vm._v("Email ")]
                  ),
                  _vm._v(" "),
                  _vm.existEmail
                    ? _c(
                        "div",
                        {
                          staticClass: "invalid-feedback",
                          staticStyle: { display: "block" }
                        },
                        [
                          _vm.existEmailSocial
                            ? _c("span", [
                                _vm._v(
                                  "Email digitato già presente. Sei registrato con:\n                "
                                ),
                                _c(
                                  "strong",
                                  { staticClass: "text-capitalize" },
                                  [_vm._v(_vm._s(_vm.existEmailSocial))]
                                )
                              ])
                            : _c("span", [
                                _vm._v("Email digitato già presente")
                              ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("email")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("email")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "group" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.province,
                          expression: "province"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("province"),
                        valid: !!_vm.province
                      },
                      attrs: {
                        autocomplete: "randomy",
                        id: "province",
                        name: "province",
                        "data-vv-as": "Provincia"
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.province = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.provOk($event)
                          }
                        ]
                      }
                    },
                    [
                      !_vm.shipData.province
                        ? _c("option", {
                            attrs: {
                              disabled: "",
                              value: "",
                              selected: "selected"
                            }
                          })
                        : _c(
                            "option",
                            {
                              attrs: { selected: "selected" },
                              domProps: { value: _vm.shipData.province }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.shipData.province) +
                                  "\n              "
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _vm._l(_vm.provincies, function(province) {
                        return _c(
                          "option",
                          {
                            key: province.sigla,
                            domProps: {
                              value: province.sigla,
                              selected: province.sigla == _vm.shipData.province
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(province.sigla) +
                                " - " +
                                _vm._s(province.provincia) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "province" }
                    },
                    [_vm._v("Provincia ")]
                  ),
                  _vm._v(" "),
                  _vm.provinciesState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadProvince",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("province")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("province")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "group" }, [
                  !_vm.zip && !_vm.city
                    ? _c("div", { staticClass: "fix-2" }, [
                        _vm._v(_vm._s(_vm.myzip))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.zip,
                          expression: "zip"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("zip"),
                        valid: !!_vm.zip
                      },
                      attrs: {
                        autocomplete: "randomi",
                        id: "zip",
                        name: "zip",
                        "data-vv-as": "Cap",
                        disabled: _vm.zipsState
                      },
                      on: {
                        click: _vm.checkZip,
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.zip = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      !_vm.shipData.zip
                        ? _c("option", {
                            attrs: { value: "", disabled: "" },
                            domProps: { selected: true }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.zips, function(zip) {
                        return _c(
                          "option",
                          {
                            key: zip.cap,
                            domProps: {
                              value: zip.cap,
                              selected: zip.cap == _vm.shipData.zip
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(zip.cap) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "zip" } },
                    [
                      _vm._v("Codice postale\n              "),
                      _vm.zipError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli il comune")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.zipsState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadZips",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("zip")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("zip")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "group" }, [
                  !_vm.city
                    ? _c("div", { staticClass: "fix-2" }, [
                        _vm._v(_vm._s(_vm.mycity))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.city,
                          expression: "city"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: {},
                          expression: "{}"
                        }
                      ],
                      staticClass: "form-control",
                      class: {
                        "is-invalid": _vm.errors.has("city"),
                        valid: !!_vm.city
                      },
                      attrs: {
                        autocomplete: "randomu",
                        id: "city",
                        name: "city",
                        "data-vv-as": "Comune",
                        disabled: _vm.citiesState
                      },
                      on: {
                        click: _vm.checkProvince,
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.city = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      !_vm.shipData.city
                        ? _c("option", {
                            attrs: {
                              disabled: "",
                              value: "mycity",
                              selected: "selected"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: { else: "", selected: "selected" },
                          domProps: { value: { city: _vm.shipData.city } }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.shipData.city) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.cities, function(city) {
                        return _c(
                          "option",
                          {
                            key: city.comune,
                            domProps: {
                              value: {
                                cityistat: city.istat,
                                city: city.comune
                              },
                              selected: city.comune == _vm.shipData.city
                            }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(city.comune) +
                                "\n              "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "niceInputLabel", attrs: { for: "city" } },
                    [
                      _vm._v("Comune\n              "),
                      _vm.cityError
                        ? _c("span", { staticClass: "formError" }, [
                            _vm._v("Prima scegli la provincia")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.citiesState
                    ? _c(
                        "div",
                        [
                          _c("font-awesome-icon", {
                            staticClass: "loadSpinner",
                            attrs: {
                              id: "loadCity",
                              icon: "spinner",
                              size: "1x",
                              pulse: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.errors.has("city")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("city")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 4, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address,
                        expression: "address"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { min: 5 },
                        expression: "{ min: 5 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("address"),
                      valid: !!_vm.address
                    },
                    attrs: {
                      type: "text",
                      id: "address",
                      name: "address",
                      "data-vv-as": "Indirizzo"
                    },
                    domProps: { value: _vm.address },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.address = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel",
                      attrs: { for: "address" }
                    },
                    [_vm._v("Indirizzo")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("address")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("address")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { key: 10, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { passwordCheck: true, min: 8, max: 56 },
                        expression: "{ passwordCheck: true, min: 8, max: 56 }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("password"),
                      valid: !!_vm.password
                    },
                    attrs: {
                      type: "password",
                      autocomplete: "on",
                      id: "password",
                      name: "password"
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel label",
                      attrs: { for: "password" }
                    },
                    [_vm._v("Nuova Password")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("password")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("password")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { key: 11, staticClass: "group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirm_password,
                        expression: "confirm_password"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: !!_vm.password,
                          confirmed: _vm.password,
                          passwordCheck: true,
                          min: 8,
                          max: 56
                        },
                        expression:
                          "{\n                required: !!password,\n                confirmed: password,\n                passwordCheck: true,\n                min: 8,\n                max: 56,\n              }"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.errors.has("confirm_password"),
                      valid: !!_vm.confirm_password
                    },
                    attrs: {
                      type: "password",
                      autocomplete: "on",
                      id: "confirm_password",
                      name: "confirm_password",
                      "data-vv-as": "conferma password"
                    },
                    domProps: { value: _vm.confirm_password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.confirm_password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "highlight" }),
                  _vm._v(" "),
                  _c("span", { staticClass: "bar" }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "niceInputLabel label",
                      attrs: { for: "password" }
                    },
                    [_vm._v("Conferma Nuova Password")]
                  ),
                  _vm._v(" "),
                  _vm.errors.has("confirm_password")
                    ? _c("div", { staticClass: "invalid-feedback" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.errors.first("confirm_password")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _vm.phone
                  ? _c("div", { key: 8, staticClass: "group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phone,
                            expression: "phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: {
                              max: 11,
                              min: 8,
                              notZeros: true,
                              regex: /^[3]+/
                            },
                            expression:
                              "{\n                max: 11,\n                min: 8,\n                notZeros: true,\n                regex: /^[3]+/,\n              }"
                          }
                        ],
                        staticClass: "form-control dis",
                        class: {
                          "is-invalid": _vm.errors.has("phone"),
                          valid: !!_vm.phone,
                          dis: _vm.phone
                        },
                        attrs: {
                          type: "text",
                          placeholder:
                            "Inserisci il tuo numero di telefono nella pagina di caricamento",
                          disabled: "",
                          id: "phone",
                          name: "phone",
                          "data-vv-as": "Telefono"
                        },
                        domProps: { value: _vm.phone },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.phone = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "highlight" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "bar" }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "niceInputLabel",
                          attrs: { for: "phone" }
                        },
                        [_vm._v("Telefono ")]
                      ),
                      _vm._v(" "),
                      _vm.errors.has("phone")
                        ? _c("div", { staticClass: "invalid-feedback" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.errors.first("phone")) +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-10 mb-5 mb-md-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-group back-white",
                    staticStyle: { "border-radius": "10px" }
                  },
                  [
                    _c("div", { staticClass: "form-check pl-0" }, [
                      _c("div", { staticClass: "group" }, [
                        _vm.privacy == 1
                          ? _c(
                              "div",
                              {
                                staticClass: "form-check form-check-inline mt-2"
                              },
                              [
                                _c("label", { staticClass: "Bold black" }, [
                                  _vm._v(
                                    "\n                    Informativa accettata\n                    "
                                  ),
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "24",
                                        height: "24",
                                        fill: "#173f53"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          "fill-rule": "evenodd",
                                          d:
                                            "M17.818 5.693a.35.35 0 0 1 .27-.11.47.47 0 0 1 .305.11l.946 1.057c.09.073.135.17.135.292a.47.47 0 0 1-.135.328L9.203 18.307a.35.35 0 0 1-.27.11.47.47 0 0 1-.304-.11l-4.494-4.885A.356.356 0 0 1 4 13.13a.47.47 0 0 1 .135-.328l.946-1.02a.407.407 0 0 1 .304-.147c.113 0 .203.049.27.146l3.278 3.537 8.885-9.625z"
                                        }
                                      })
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("privacy"),
                                expression: "errors.has('privacy')"
                              }
                            ],
                            staticClass: "errorMes"
                          },
                          [
                            _vm._v(
                              "\n                  Il consenso deve essere accettato oppure rifiutato\n                "
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._m(1)
                  ]
                ),
                _vm._v(" "),
                _vm._m(2)
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c(
        "h1",
        { staticClass: "h1 darkBlue center mb-5 pt-5 mt-5 uppercase Bold" },
        [_c("b", [_vm._v("Il tuo profilo")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-check pl-0" }, [
      _c("div", { staticClass: "group" }, [
        _c("label", { staticClass: "form-check-label mb-3 Medium" }, [
          _vm._v(
            "\n                  Puoi consultare la normativa sulla privacy cliccando qui:\n                  "
          ),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.lierac.it/privacy-cookie-policy.html",
                target: "_blank"
              }
            },
            [_vm._v("\n                    Privacy Policy ")]
          ),
          _vm._v(".\n                ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center mt-5 mt-md-3 mb-md-0 mb-5 pb-5" }, [
      _c(
        "button",
        { staticClass: "btn btn-primary mr-md-5", attrs: { tag: "button" } },
        [_vm._v("\n              CONFERMA MODIFICHE\n            ")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcfb22e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcfb22e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/index.vue
// module id = null
// module chunks = 